/* eslint-disable */
import React from "react";
import { showToast } from "../../../shared/helpers/show-toast";
import { formatDateRange } from "../utils";

const ChallengeInfoBox = ({
  challengeInfo,
  joinedChallenge,
  onConfirmChallengeModal,
  isError,
}) => {
  return (
    <div className="challenge-info-box">
      <h3 style={{ fontSize: "24px", fontWeight: "600" }}>
        {challengeInfo?.name}
      </h3>
      <div style={{ margin: 0, color: "#475467", fontSize: "18px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: "10px",
          }}
        >
          <div className="usga-calendar-small" />
          <span>
            {formatDateRange(challengeInfo?.start_date, challengeInfo?.end_date)}
          </span>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: "10px",
          }}
        >
          <div className="people-small" />
          <span>{`${challengeInfo?.golfers} golfer${
            challengeInfo?.golfers > 1 ? "s" : ""
          }`}</span>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: "10px",
          }}
        >
          <div className="golfcup-small" />
          <span>3+ rounds to qualify</span>
        </div>
      </div>

      {!joinedChallenge ? (
        <div
          className="join-button-container"
          style={{ marginTop: "20px", gap: "5px" }}
        >
          <button
            className="btn fill blue"
            onClick={onConfirmChallengeModal}
            disabled={isError}
            style={{
              width: "80%",
              padding: "10px",
              fontSize: "16px",
            }}
          >
            Join Challenge
          </button>
          <div className="share-row">
            <div className="usga-share" />
            <div
              style={{
                fontSize: "16px",
                marginLeft: "5px",
                fontWeight: "600",
                cursor: "pointer",
                color: "#00365F",
              }}
              onClick={() => {
                navigator.clipboard.writeText(
                  window.location.origin +
                    `/challenges/${challengeInfo?.id}`
                );
                showToast("Challenge link copied to clipboard!");
              }}
            >
              SHARE
            </div>
          </div>
        </div>
      ) : (
        <div className="join-button-container" style={{ marginTop: "30px" }}>
          <div className="share-row">
            <div className="usga-share" />
            <div
              style={{
                fontSize: "16px",
                marginLeft: "5px",
                fontWeight: "600",
                cursor: "pointer",
                color: "#00365F",
              }}
              onClick={() => {
                navigator.clipboard.writeText(
                  window.location.origin +
                    `/challenges/${challengeInfo?.id}`
                );
                showToast("Challenge link copied to clipboard!");
              }}
            >
              SHARE
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChallengeInfoBox;
